import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/insurance";

export default {
  getBranches() {
    return axios.get(`${baseUrl}/branches`).then((response) => response.data);
  },

  // TODO when merging Staging, refactor the routes in staging matching this pattern
  getViewGroupByBranch(brancheId) {
    return axios.get(`${baseUrl}/view_group/by_branche/${brancheId}`)
      .then((response) => response.data);
  },
};
